import axios from 'axios';
import { change } from 'redux-form';
import { browserHistory } from 'react-router';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';
import moment from 'moment';

import {
    REQUEST_RECEIVES,
    FETCH_RECEIVES_SUCCESS,
    FETCH_RECEIVES_FAILURE,
    SELECT_RECEIVE,
    RESET_CURRENT_RECEIVE,
    REQUEST_CREATING_RECEIVE,
    CREATE_RECEIVE_SUCCESS,
    CREATE_RECEIVE_FAILURE,
    RESET_CREATE_RECEIVE,
    REQUEST_EDITING_RECEIVE,
    EDIT_RECEIVE_SUCCESS,
    EDIT_RECEIVE_FAILURE,
    REQUEST_RECEIVE_DETAIL,
    FETCH_RECEIVE_DETAIL_SUCCESS,
    FETCH_RECEIVE_DETAIL_FAILURE,
    COMPLETE_PURCHASE_ORDER,
    COMPLETE_PURCHASE_ORDER_SUCCESS,
    COMPLETE_PURCHASE_ORDER_FAILURE,
    FETCH_RECEIVE_HISTORY,
    FETCH_RECEIVE_HISTORY_SUCCESS,
    FETCH_RECEIVE_HISTORY_FAILURE,
    SELECT_RECEIVE_HISTORY,
    RESET_CURRENT_RECEIVE_HISTORY,
    FETCH_RECEIVE_HISTORY_DETAIL,
    FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
    FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
    REQUEST_EDITING_RECEIVE_HISTORY,
    EDIT_RECEIVE_HISTORY_SUCCESS,
    EDIT_RECEIVE_HISTORY_FAILURE,
    RESET_EDIT_RECEIVE_HISTORY,
    DELETE_RECEIVE,
    DELETE_RECEIVE_FINISHED,
    RESET_DELETE_STATUS,
    ATTACH_FILES,
    ATTACH_FILES_SUCCESS,
    ATTACH_FILES_FAILURE,
    FETCH_ATTACHED_FILES,
    FETCH_ATTACHED_FILES_SUCCESS,
    FETCH_ATTACHED_FILES_FAILURE,
    DELETE_ATTACHED_FILES,
    DELETE_ATTACHED_FILES_SUCCESS,
    DELETE_ATTACHED_FILES_FAILURE,
    RESET_ATTACHED_FILES
} from './type'

import {
    RECEIVE_URL,
    PURCHASE_ORDERS_URL,
    PURCHASE_ORDER_COMPLETE_URL,
    UPLOAD_URL,
    WAREHOUSES_URL
} from './url'

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchReceives() {
    return dispatch => {
        dispatch(requestReceives());
        return axios.get(RECEIVE_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchReceivesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchReceivesFailure(err));
            });
    }
}

export function requestReceives() {
    return {
        type: REQUEST_RECEIVES,
    };
}

export function fetchReceivesSuccess(receives) {
    return {
        type: FETCH_RECEIVES_SUCCESS,
        payload: receives
    };
}

export function fetchReceivesFailure(error) {
    return {
        type: FETCH_RECEIVES_FAILURE,
        payload: error
    };
}

export function selectReceive(receive) {
    return {
        type: SELECT_RECEIVE,
        payload: receive
    };
}

export function resetCurrentReceive() {
    return {
        type: RESET_CURRENT_RECEIVE
    }
}


// Actions to deal with the promise of posting function.

export function createReceive(
  PostingDate,
  InvoiceDate,
  HandlingCost,
  MiscCost,
  ShippingCost,
  PriceAdjustment,
  ShareCost,
  PONum,
  Note,
  Warehouse_id,
  VendorPicklistNum,
  Vendor_id,
  ReceivingPrice,
  InvoiceFinalPrice,
  Warehouse_Receive_Line,
  {
    InvoiceNum,
    PackingNum,
    container_num,
  },
  completeReceive
) {
  // let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
  Warehouse_Receive_Line.map(
      product => {
          product['StorageRate'] = product.StorageRate || 0;
          if (product.Product_id){
            product.Product_id = product.Product_id.Product_id || product.Product_id;
          }
          if(product['subWeights']) {
            product['Weights'] = [];
            product.subWeights.map(w => {
              product['Weights'].push(parseFloat(w.Weight))
            })
          }
          if(!product.Remark){
            product.Remark = "";
          }
      }
  )

  InvoiceFinalPrice = parseFloat(InvoiceFinalPrice);
        return dispatch => {
      if (Warehouse_Receive_Line.length > 0) {
        dispatch({ type: REQUEST_CREATING_RECEIVE });
        axios.post(RECEIVE_URL + 'history/' + PONum,
            {
                PostingDate,
                InvoiceDate,
                HandlingCost,
                MiscCost,
                ShippingCost,
                PriceAdjustment,
                ShareCost,
                PONum,
                Note,
                Warehouse_id,
                VendorPicklistNum,
                Vendor_id,
                // TotalPrice,
                // FinalPrice,
                ReceivingPrice,
                InvoiceNum,
                PackingNum,
                container_num,
                InvoiceFinalPrice,
                Warehouse_Receive_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              if(/*response.status == 200 || */completeReceive == true){
                axios.get(PURCHASE_ORDERS_URL + PONum + '/complete/',
                  {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                  }
                )
                .then(res => {
                  dispatch(createReceiveSuccess(response));
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    err.data = DEFAULT_ERROR;
                  }
                  dispatch(createReceiveFailure(err));
                });
              } else {
                dispatch(createReceiveSuccess(response));
                // browserHistory.push('/inventories/receive/');
              }
            }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(createReceiveFailure(err));
            });
        } else if (Warehouse_Receive_Line.length === 0) {
          if (/*response.status == 200 || */completeReceive === true) {
            dispatch({ type: REQUEST_CREATING_RECEIVE });
            axios.get(PURCHASE_ORDERS_URL + PONum + '/complete/',
              {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
            )
            .then(res => {
              dispatch(createReceiveSuccess(res));
              browserHistory.push('/inventories/receive/');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createReceiveFailure(err));
            });
          }
        }
    }
}

// export function requestCreatingReceive() {
//     return {
//         type: REQUEST_CREATING_RECEIVE
//     }
// }

export function createReceiveSuccess(response) {
    return {
        type: CREATE_RECEIVE_SUCCESS,
        payload: response,
    }
}

export function createReceiveFailure(error) {
    return {
        type: CREATE_RECEIVE_FAILURE,
        payload: error
    }
}

export function resetCreateReceive() {
  return {
    type: RESET_CREATE_RECEIVE,
  };
}

export function editReceive({
    Receive_id,
    ReceiveNum,
    RefNum,
    Name,
    Description,
    CreditStatus,
    IsActive,
    Purchaser_User_id,
    PaymentTerm_id,
    ShippingContact,
    ShippingAddress,
    MailingAddress,
    MailingContact,
    BillingAddress,
    BillingContact,
    Purchase_Order_Line,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_RECEIVE });
        axios.put((RECEIVE_URL + 'history/' + Receive_id),
            {
                ReceiveNum,
                RefNum,
                Name,
                Description,
                CreditStatus,
                IsActive,
                Purchaser_User_id,
                PaymentTerm_id: PaymentTerm_id.value,
                ShippingContact,
                ShippingAddress,
                MailingAddress,
                MailingContact,
                BillingAddress,
                BillingContact,
                Purchase_Order_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editReceiveSuccess());
              browserHistory.push('/receives'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editReceiveFailure(err));
            });
    }
}

// export function requestCreatingReceive() {
//     return {
//         type: REQUEST_EDITING_RECEIVE
//     }
// }

export function editReceiveSuccess() {
    return {
        type: EDIT_RECEIVE_SUCCESS
    }
}

export function editReceiveFailure(error) {
    return {
        type: EDIT_RECEIVE_FAILURE,
        payload: error
    }
}

// Fetch the detail page.

export function fetchReceiveDetail(PONum) {
    return dispatch => {
        dispatch(requestReceiveDetail());
        return axios.get(RECEIVE_URL + PONum,
        // return axios.get(RECEIVE_URL + 'history/' + 'P1609220000',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchReceiveDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchReceiveDetailFailure(err));
            });
    }
}

export function requestReceiveDetail() {
    return {
        type: REQUEST_RECEIVE_DETAIL,
    };
}

export function fetchReceiveDetailSuccess(receiveDetail) {
    return {
        type: FETCH_RECEIVE_DETAIL_SUCCESS,
        payload: receiveDetail
    };
}

export function fetchReceiveDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_DETAIL_FAILURE,
        payload: error
    };
}


export function convertPOToReceive(PO_id) {
    return dispatch => {
        dispatch(requestReceiveDetail());
        return axios.get(RECEIVE_URL + PO_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchReceiveDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchReceiveDetailFailure(err));
            });
    }
}

export function completePurchaseOrder(PONum) { //force to complete
    return dispatch => {
      dispatch({type: COMPLETE_PURCHASE_ORDER}); //add this type later...
      return axios.get(PURCHASE_ORDER_COMPLETE_URL + PONum,
        {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(completePurchaseOrderSuccess());
        browserHistory.push('/inventories/receive/');
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(completePurchaseOrderFailure(err));
      });
    }
}

export function completePurchaseOrderSuccess() {
  return {
    type: COMPLETE_PURCHASE_ORDER_SUCCESS
  };
}

export function completePurchaseOrderFailure(error) {
  return {
    type: COMPLETE_PURCHASE_ORDER_FAILURE,
    payload: error
  };
}

export function fetchReceiveHistory(status) {
  if(status == "Arrived") {
    return dispatch => {
      dispatch({type: FETCH_RECEIVE_HISTORY}); //add this type later...
      return axios.get(RECEIVE_URL + 'history/?ArrivalStatus=Arrived',
        {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(fetchReceiveHistorySuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReceiveHistoryFailure(err));
      });
    }
  }
  return dispatch => {
    dispatch({type: FETCH_RECEIVE_HISTORY}); //add this type later...
    return axios.get(RECEIVE_URL + 'history/',
      {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchReceiveHistorySuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchReceiveHistoryFailure(err));
    });
  }
}

export function fetchReceiveHistoryByDate(SalesOrder_gte, SalesOrder_lte, days, isReport) {
  const dates = toFromDates(days, SalesOrder_gte, SalesOrder_lte);
  let report = isReport;
  if (isReport) {
    report = '&Report=true';
  } else {
    report = '&Report=false';
  }

  return (dispatch) => {
    dispatch({ type: FETCH_RECEIVE_HISTORY }); // add this type later...
    return axios.get(
      `${WAREHOUSES_URL}search/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}${report}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReceiveHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReceiveHistoryFailure(err));
      });
  };
}

export function fetchReceiveHistorySuccess(receiveHistory) {
    return {
        type: FETCH_RECEIVE_HISTORY_SUCCESS,
        payload: receiveHistory
    };
}

export function fetchReceiveHistoryFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_FAILURE,
        payload: error
    };
}

export function selectReceiveHistory(receiveHisoty) {
    return {
        type: SELECT_RECEIVE_HISTORY,
        payload: receiveHisoty
    };
}

export function resetCurrentReceiveHistory() {
    return {
        type: RESET_CURRENT_RECEIVE_HISTORY
    }
}

export function fetchReceiveHistoryDetail(WarehouseReceive_id) {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL });
        return axios.get(RECEIVE_URL + 'line/inbound/' + WarehouseReceive_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchReceiveHistoryDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchReceiveHistoryDetailFailure(err));
            });
    }
}

export function fetchReceiveHistoryDetailSuccess(receiveHistoryDetail) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
        payload: receiveHistoryDetail
    };
}

export function fetchReceiveHistoryDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
        payload: error
    };
}

export function fetchAllReceiveHistoryDetail() {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL });
        return axios.get(RECEIVE_URL + 'line/inbound/',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchAllReceiveHistoryDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchAllReceiveHistoryDetailFailure(err));
            });
    }
}

export function fetchAllReceiveHistoryDetailSuccess(receiveHistoryDetail) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
        payload: receiveHistoryDetail
    };
}

export function fetchAllReceiveHistoryDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
        payload: error
    };
}

export function fetchReceiveHistoryDetailRecord(WarehouseReceive_id, Warehouse_ReceiveCompleted_id) {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD });
          // if(Warehouse_ReceiveCompleted_id) {
          //   return axios.get(RECEIVE_URL + 'complete/' + Warehouse_ReceiveCompleted_id,
          //       {
          //           headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          //       })
          //       .then(response => {
          //           dispatch(fetchReceiveHistoryDetailRecordSuccess(response));
          //       })
          //       .catch(response => {
          //           dispatch(fetchReceiveHistoryDetailRecordFailure(response));
          //       })
          // }
          // else {
            return axios.get(RECEIVE_URL + 'history/' + WarehouseReceive_id,
                {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                })
                .then(response => {
                  dispatch(fetchReceiveHistoryDetailRecordSuccess(response));
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    err.data = DEFAULT_ERROR;
                  }
                  dispatch(fetchReceiveHistoryDetailRecordFailure(err));
                });
          // }
    }
}

export function fetchReceiveHistoryDetailRecordSuccess(receiveHistoryDetail) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
        payload: receiveHistoryDetail
    };
}

export function fetchReceiveHistoryDetailRecordFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
        payload: error
    };
}

/* Edid receiving and edit purchase payment are sharing this action */
export function editReceiveHistory(
  { WarehouseReceiveCompleted_id,
    WarehouseReceive_id,
    PaymentStatus,
    PostingDate,
    InvoiceDate,
    HandlingCost,
    MiscCost,
    ShippingCost,
    PriceAdjustment,
    InvoiceFinalPrice,
    InvoiceNum,
    PackingNum,
    container_num,
    Note
    },
    Warehouse_Receive_Line, isPayment, TotalPrice, FinalPrice) {
    //let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
    if(PaymentStatus)
      PaymentStatus = PaymentStatus.value || PaymentStatus;
    if(WarehouseReceiveCompleted_id) {
      let Warehouse_Receive_Line_Completed = Warehouse_Receive_Line;
      Warehouse_Receive_Line_Completed.map(
          product => {
              if(product['subWeights']) {
                product['Weights'] = [];
                product.subWeights.map(w => {
                  product['Weights'].push(parseFloat(w.Weight))
                })
              }
          }
      )
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_RECEIVE_HISTORY });
          axios.put((RECEIVE_URL + 'complete/' + WarehouseReceiveCompleted_id),
              {
                  PaymentStatus,
                  Warehouse_Receive_Line_Completed,
                  HandlingCost,
                  PostingDate,
                  InvoiceDate,
                  MiscCost,
                  ShippingCost,
                  PriceAdjustment,
                  InvoiceFinalPrice,
                  TotalPrice,
                  FinalPrice,
                  InvoiceNum,
                  PackingNum,
                  container_num,
                  Note
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editReceiveHistorySuccess(response));
                // if(isPayment === "isPayment") {
                //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
                // }
                // else
                // console.log("did it get here?");
                // browserHistory.push('/inventories/receiveHistory'); // If editd succesfully, refresh the paymentTerm page.
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(editReceiveHistoryFailure(err));
              });
      }
    }
    else {
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_RECEIVE_HISTORY });
          Warehouse_Receive_Line.map(
              product => {
                  if(product['subWeights']) {
                    product['Weights'] = [];
                    product.subWeights.map(w => {
                      product['Weights'].push(parseFloat(w.Weight))
                    })
                  }
              }
          )
          axios.put((RECEIVE_URL + 'history/' + WarehouseReceive_id),
              {
                  PaymentStatus,
                  PostingDate,
                  InvoiceDate,
                  Warehouse_Receive_Line,
                  HandlingCost,
                  MiscCost,
                  ShippingCost,
                  PriceAdjustment,
                  InvoiceFinalPrice,
                  TotalPrice,
                  FinalPrice,
                  InvoiceNum,
                  PackingNum,
                  container_num,
                  Note
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editReceiveHistorySuccess(response));
                // if(isPayment === "isPayment") {
                //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
                // }
                // else
                // console.log("did it get here?");
                // browserHistory.push('/inventories/receiveHistory');
               }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                dispatch(editReceiveHistoryFailure(err));
              });
      }
    }
}

export function editReceiveHistorySuccess(payload) {
    return {
        type: EDIT_RECEIVE_HISTORY_SUCCESS,
        payload,
    };
}

export function editReceiveHistoryFailure(error) {
    return {
        type: EDIT_RECEIVE_HISTORY_FAILURE,
        payload: error
    };
}

export function resetEditReceiveHistory() {
  return {
    type: RESET_EDIT_RECEIVE_HISTORY,
  };
}

export function voidReceiving(WarehouseReceiveId) {
  return dispatch => {
    dispatch({type: DELETE_RECEIVE});
    return axios.delete(RECEIVE_URL + 'history/' + WarehouseReceiveId,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(voidReceivingFinished(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidReceivingFinished(err));
      });
  }
}

export function voidReceivingFinished(response) {
    return {
        type: DELETE_RECEIVE_FINISHED,
        payload: response,
    };
}

export function resetDeleteStatus() {
  return {
    type: RESET_DELETE_STATUS
  }
}

export function attachFile(WarehouseReceiveNum, files) {
  return dispatch => {
    dispatch({type: ATTACH_FILES});
    var data = new FormData();
    data.append('file', files[0]);
    data.append('WarehouseReceiveNum', WarehouseReceiveNum);

    return axios.post(UPLOAD_URL + 'warehouse/', data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(attachFileSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(attachFileFailure(err));
      });
  }
}

export function attachFileSuccess() {
    return {
        type: ATTACH_FILES_SUCCESS,
    };
}

export function attachFileFailure(error) {
    return {
        type: ATTACH_FILES_FAILURE,
        payload: error
    };
}

export function fetchAttachedFile(WarehouseReceiveNum, Name) {
  return dispatch => {
    dispatch({type: FETCH_ATTACHED_FILES});
    return axios.post(UPLOAD_URL + 'download/warehouse/',
    {
      WarehouseReceiveNum,
      Name
    },
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(fetchAttachedFileSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchAttachedFileFailure(err));
    });
  }
}

export function fetchAttachedFileSuccess(files) {
  return {
    type: FETCH_ATTACHED_FILES_SUCCESS,
    payload: files
  }
}

export function fetchAttachedFileFailure(error) {
  return {
    type: FETCH_ATTACHED_FILES_FAILURE,
    payload: error
  }
}

export function deleteAttachedFile(WarehouseReceiveNum, Name) {
  return dispatch => {
    dispatch({type: DELETE_ATTACHED_FILES});
    return axios.post(UPLOAD_URL + 'delete/warehouse/',
    {
      WarehouseReceiveNum,
      Name
    },
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(deleteAttachedFileSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(deleteAttachedFileFailure(err));
    });
  }
}

export function deleteAttachedFileSuccess(files) {
  return {
    type: DELETE_ATTACHED_FILES_SUCCESS,
    payload: files
  }
}

export function deleteAttachedFileFailure(error) {
  return {
    type: DELETE_ATTACHED_FILES_FAILURE,
    payload: error
  }
}

export function resetAttachedFile() {
  return {
    type: RESET_ATTACHED_FILES
  }
}

export function setPostingDate(date, Form) {
  return dispatch => {
    dispatch(change(Form, 'PostingDate', date));
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/receive_actions.js